import {
  Footprints, Phone, Linkedin, MessageCircle, MapPin as MapPinIcon, Upload,
  Snowflake, Thermometer, Flame, Zap,
} from "lucide-react";

export const STATUSES = ["À contacter", "Contacté", "En discussion", "RDV planifié", "Converti", "Sans suite"];

// All status pills on dark surface, muted palette
export const PILL_COLORS = {
  "À contacter":  { bg: "bg-emerald-500/10",  text: "text-emerald-300",   border: "border-emerald-500/30", dot: "bg-emerald-400" },
  "Contacté":     { bg: "bg-amber-500/10",    text: "text-amber-300",    border: "border-amber-500/30",  dot: "bg-amber-400" },
  "En discussion":{ bg: "bg-sky-500/10",      text: "text-sky-300",      border: "border-sky-500/30",    dot: "bg-sky-400" },
  "RDV planifié": { bg: "bg-emerald-500/10",  text: "text-emerald-300",  border: "border-emerald-500/30",dot: "bg-emerald-400" },
  "Converti":     { bg: "bg-emerald-500/20",  text: "text-emerald-200",  border: "border-emerald-500/50",dot: "bg-emerald-300" },
  "Sans suite":   { bg: "bg-zinc-700/30",     text: "text-zinc-500",     border: "border-zinc-700",      dot: "bg-zinc-500" },
};

export const SOURCE_ICONS = {
  "Road Maps": Footprints, Téléphone: Phone, LinkedIn: Linkedin, WhatsApp: MessageCircle, "Géo-radar": MapPinIcon, Import: Upload,
};

export const TEMP_META = {
  qualifie: { label: "Lead qualifié", icon: Zap,         color: "text-emerald-300",  border: "border-emerald-500/40",  bg: "bg-emerald-500/10" },
  chaud:    { label: "Chaud",         icon: Flame,       color: "text-rose-300",    border: "border-rose-500/40",    bg: "bg-rose-500/10" },
  tiede:    { label: "Tiède",         icon: Thermometer, color: "text-amber-300",   border: "border-amber-500/40",   bg: "bg-amber-500/10" },
  froid:    { label: "Froid",         icon: Snowflake,   color: "text-sky-300",     border: "border-sky-500/40",     bg: "bg-sky-500/10" },
};

export function classifyProspect(p) {
  const status = p.status || "";
  const interest = (p.interest_level || "").toLowerCase();
  const score = Number(p.score) || 0;
  if (status === "Converti" || status === "RDV planifié" || interest.includes("très chaud")) return "qualifie";
  if (interest.includes("chaud") || score >= 70 || status === "En discussion") return "chaud";
  if (interest.includes("tiède") || interest.includes("tiede") || score >= 45 || status === "Contacté") return "tiede";
  return "froid";
}
